import React from "react";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import InputLabel from "@mui/material/InputLabel";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import { Link } from "react-router-dom";
import "./footer.css";

const Footer = () => {
  return (
    <>
      <div className="footer">
        <div className="footertop">
          <div>
            <h2>Get in touch</h2>
            <div>Customer Reviews</div>
            <div>Our Blogs</div>
            <div>Jewellery Care</div>
            <div>Offers & Promotions</div>
          </div>
          <div>
            <h2>info & help</h2>
            <div>
              <Link className="footlink" to="/terms">
                {" "}
                Terms Condtions
              </Link>
            </div>
            <div>
              <Link className="footlink" to="/privacy">
                {" "}
                Privacy Policy
              </Link>
            </div>
            <div>
              <Link className="footlink" to="/refund">
                {" "}
                Refund & Return
              </Link>
            </div>
            <div>
              <Link className="footlink" to="/shipping">
                {" "}
                Shipping Policy
              </Link>
            </div>
            <div>
              <Link className="footlink" to="/FAQ">
                {" "}
                FAQs & Support
              </Link>
            </div>
          </div>
          <div>
            <h2>Contact us</h2>
            <div>BIS : HM/C - 6290031216</div>
            <div>Cuttack,Odisha</div>
            <div>
              {" "}
              <a href="tel:+917008650539" className="call-button">
                +91 7008 650 539
              </a>
            </div>
            <div>sales@shagoon.com</div>
          </div>
        </div>
        <div className="footerbotom">
          <div>
            <FormControl sx={{ width: "30ch" }} variant="outlined">
              <InputLabel htmlFor="standard-adornment-password">
                Subscribe us
              </InputLabel>
              <OutlinedInput
                id="outlined-adornment-password"
                type="text"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        console.log("clicked");
                      }}
                      edge="end"
                    >
                      <ArrowForwardRoundedIcon />
                    </IconButton>
                  </InputAdornment>
                }
                label="Subscribe Us"
              />
            </FormControl>
          </div>
          <div className="social">
            <div>
              <Link to="/facebook">
                <FacebookIcon />
              </Link>
            </div>
            <div>
              <Link to="https://www.instagram.com/shagoon_bangles?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==">
                <InstagramIcon />
              </Link>
            </div>
            <div>
              <Link to="/twitter">
                <TwitterIcon />
              </Link>
            </div>
          </div>
        </div>
        <span>
          <h6 style={{ color: "grey" }}>@2024 Shagoon copyright</h6>
        </span>
      </div>
    </>
  );
};

export default Footer;
